import React from "react"
import ReactSVG from 'react-svg'
import Router, { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'


export const VehiclePartsSummaryBar = ({ count, onReset }) => {
	const { t } = useTranslation('common')

	return (
		<div className='vehicle-parts-summary-bar'>
			<p>{t('PRONAĐENO')}: <strong>{count || 0}</strong></p>

			<button
				className='ads-filter-vehicle-parts-header__reset'
				onClick={onReset}
			>
				<ReactSVG
					src='/icons/161.obrisati.svg'
					beforeInjection={svg => {
						svg.setAttribute('style', 'width: 12px; height: auto; margin-right: 7px; margin-top: 3px;');
					}}
					className='pretraga-reset-filter'
				/>

				<span>{t('resetSearchVehiclePartsText')}</span>
			</button>
		</div>
	)
}

